import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const offersVisibleHit = (ids: number[]) => {
    const payload = {
        ...getTrackedSiteData(),
        offers: ids
    };

    delayHit(() => hitAlgolytics("offer_views", payload), 500)();
};
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const offersVisibleHit = (ids: number[]) => {
    const payload = {
        ...getTrackedSiteData(),
        offers: ids
    };

    delayHit(() => hitAlgolytics("offer_views", payload), 500)();
};
